import { render, staticRenderFns } from "./shop-post-tags.vue?vue&type=template&id=a2820c22"
import script from "./shop-post-tags.component.js?vue&type=script&lang=js&external"
export * from "./shop-post-tags.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCombobox,VForm})
